import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Category } from "../domain/category";
import { HttpCategoryRepository } from "../application/Category";

const repository = new HttpCategoryRepository();

export function useCategory() {
  const queryClient = useQueryClient();

  // POST: Create category
  const createCategory = useMutation({
    mutationFn: (category: Category) => repository.create(category),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["categories"] });
    },
  });

  // GET: List categories
  const {
    data: categories,
    isLoading,
    error,
  } = useQuery<Category[]>({
    queryKey: ["categories"],
    queryFn: () => repository.get(),
  });

  // GET: Get category by ID
  const getCategoryById = (id: string) => useQuery<Category | null>({
    queryKey: ["category", id],
    queryFn: () => repository.getById(id),
    enabled: !!id,
  });

  // PUT: Update category
  const updateCategory = useMutation({
    mutationFn: (category: Category) => repository.update(category),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["categories"] });
    },
  });

  // DELETE: Delete category
  const deleteCategory = useMutation({
    mutationFn: (id: string) => repository.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["categories"] });
    },
  });

  return {
    categories,
    isLoading,
    error,
    createCategory,
    getCategoryById,
    updateCategory,
    deleteCategory,
  };
}
